<template>
  <el-dialog v-model="_isShow" width="90%" top="0" lock-scroll center show-close destroy-on-close :title="label">
    <div class="mb-4">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="date" :label="$t('barcode.tracking_date')" width="180" />
        <el-table-column prop="value" :label="$t('value')" />
      </el-table>
    </div>
    <el-button type="primary" class="w-full" @click="closeDialog">
      {{ $t('cancel') }}
    </el-button>
  </el-dialog>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { Prop, PropSync } from 'vue-property-decorator'
import { format } from 'date-fns'
import { IBarcode } from '@/utils/types'
import { DATE_TIME } from '@/utils/constants'
interface IAdjustmentDisplay {
  date: string
  value: number
}
@Options({
  emits: ['update:isShow'],
  name: 'AdjustmentDataDialog',
})
export default class AdjustmentDataDialog extends Vue {
  @PropSync('isShow', { type: Boolean }) _isShow!: boolean
  @Prop({ type: String }) readonly label!: string
  @Prop({ type: String }) readonly customFieldKey!: string

  closeDialog() {
    this._isShow = false
  }

  get barcode(): IBarcode {
    return this.$store.state.barcode?.barcode
  }

  get tableData(): IAdjustmentDisplay[] {
    const result = [] as IAdjustmentDisplay[]
    if (this.barcode.trackingData) {
      for (const tdData of this.barcode.trackingData) {
        if (tdData.customFields?.[this.customFieldKey]) {
          result.push({
            date: format(new Date(tdData.audit?.trackedDateTime as string), DATE_TIME.WITH_SECOND),
            value: tdData.customFields?.[this.customFieldKey]?.adjustment || 0,
          })
        }
      }
    }
    if (this.barcode.activationData?.customFields?.[this.customFieldKey]) {
      result.unshift({
        date: this.$t('barcode.original_value'),
        value: this.barcode.activationData.customFields[this.customFieldKey]?.adjustment || 0,
      })
      result.push({
        date: this.$t('barcode.current_value'),
        value: this.barcode.activationData.customFields[this.customFieldKey]?.currentValue || 0,
      })
    }

    return result
  }
}
</script>
<style lang="scss" scoped></style>
